import { baseApi } from './axios';

export const signUp = async ({ name, email, password, domainKey }: any) => {
	const response = await baseApi.post('/auth/register', {
		name,
		email,
		password,
		domainKey,
	});

	return response;
};

export const signIn = async ({ email, password }: any) => {
	const response = await baseApi.post('/auth/signin', {
		email,
		password,
	});
	return response;
};

export const signOut = async () => {
	const response = await baseApi.get('/auth/signout');
	return response;
};

export const getUser = async () => {
	const response = await baseApi.get('/auth/me');
	return response;
};

export const getUserProfile = async () => {
	const response = await baseApi.get('/user-profile');
	return response;
};

export const updateUserProfile = async (data: any) => {
	console.log(data);
	const response = await baseApi.patch('/user-profile', data);
	return response;
};

export const sendEmailVerificationOTP = async () => {
	const response = await baseApi.get('/email-verification/send-otp');
	return response;
};
// verify-otp
export const verifyEmailVerificationOTP = async ({ otp }: { otp: string }) => {
	const response = await baseApi.post('/email-verification/verify-otp', {
		otp,
	});
	return response;
};
// forgot-password
export const sendForgotPasswordLink = async ({ email }: { email: string }) => {
	const response = await baseApi.post('/auth/forgot-password', {
		email,
	});
	return response;
};

// reset-password
export const resetPassword = async ({ password, token }: { password: string; token: string }) => {
	const response = await baseApi.post('/auth/reset-password', {
		password,
		token,
	});
	return response;
};
// Crate an endpoint to login user using token
export const verifyExternalToken = async ({ token }: { token: string }) => {
	const response = await baseApi.get(`/auth/verify-external-token/${token}`);
	return response;
};
